import nftImgNormal from '../asset/image/nft_gear1.png';
import nftImgRare from '../asset/image/nft_gear10.png';
import nftImgEliteEn from '../asset/image/nft_gear100_en.png';
import nftImgEliteKo from '../asset/image/nft_gear100_kr.png';
import nftImgEliteJa from '../asset/image/nft_gear100_jp.png';

const DEV_SALE_BOARD_URL =
  'https://script.google.com/macros/s/AKfycbywn3mXq3NO-0_0A82B3JseS2BtH8kIp0Vh0dk5WybEZZkfjCzToBS68GlLtfKYFPVk/exec';

const fetchAPI = async (url) => {
  try {
    const res = await fetch(url);
    const data = await res.json();
    return data;
  } catch (e) {
    return null;
  }
};

export const fetchSaleBoard = async () => {
  const res = await fetchAPI(DEV_SALE_BOARD_URL);
  return res?.data[0];
  // return {
  //   saleAmount: 2622,
  //   soldedNumNormal: 982,
  //   soldedNumRare: 24,
  //   soldedNumElite: 14,
  //   t1: 100,
  //   t2: 0,
  //   t3: 0,
  //   t4: 4,
  //   t5: 0,
  // };
};

export const getVipTable = () => {
  const head = [
    'GRADE',
    'GEAR_NFT_AMOUNT',
    'ADD_RATE',
    'MINING_AMOUNT',
    'ADDED_MINING_AMOUNT',
    'TOTAL_MINING_AMOUNT',
  ];

  const list = [];
  for (let i = 1; i < 11; i++) {
    const amount = i * 10;
    const per = 3650 * amount;
    const addedPer = per * 0.01 * i;

    const data = {
      grade: `VIP ${i}`,
      amount: amount,
      rate: i,
      per: per,
      addedPer: addedPer,
      totalPer: per + addedPer,
    };

    list.push(data);
  }

  return { head: head, rows: list };
};

export const getNftInfos = () => {
  const imgs = {
    1: nftImgNormal,
    2: nftImgRare,
    en: nftImgEliteEn,
    ja: nftImgEliteJa,
    ko: nftImgEliteKo,
  };
  const data = [
    {
      title: 'GRADE_N',
      img: 1,
      data: [
        { index: 1, title: 'TITLE_SALE', value: 'VALUE_SALE_NORMAL' },
        {
          index: 2,
          title: 'TITLE_PUBLISHED_AMOUNT',
          value: 'VALUE_PUBLISHED_AMOUNT_NORMAL',
        },
        {
          index: 3,
          title: 'TITLE_PRICE_PER',
          value: 'VALUE_PRICE_PER_NORMAL',
        },
        {
          index: 4,
          title: 'TITLE_RETURN_PERIOD',
          value: 'VALUE_RETURN_PERIOD_NORMAL',
        },
        {
          index: 8,
          title: 'TITLE_RETURN_RATE',
          value: 'VALUE_RETURN_RATE_NORMAL',
        },
      ],
    },
    {
      title: 'GRADE_R',
      img: 2,
      data: [
        { index: 1, title: 'TITLE_SALE', value: 'VALUE_SALE_RARE' },
        {
          index: 2,
          title: 'TITLE_PUBLISHED_AMOUNT',
          value: 'VALUE_PUBLISHED_AMOUNT_RARE',
        },
        {
          index: 3,
          title: 'TITLE_PRICE_PER',
          value: 'VALUE_PRICE_PER_RARE',
        },
        {
          index: 4,
          title: 'TITLE_RETURN_PERIOD',
          value: 'VALUE_RETURN_PERIOD_RARE',
        },
        {
          index: 8,
          title: 'TITLE_RETURN_RATE',
          value: 'VALUE_RETURN_RATE_RARE',
        },
      ],
    },
    {
      title: 'GRADE_E',
      img: 3,
      data: [
        { index: 1, title: 'TITLE_SALE', value: 'VALUE_SALE_ELITE' },
        {
          index: 2,
          title: 'TITLE_PUBLISHED_AMOUNT',
          value: 'VALUE_PUBLISHED_AMOUNT_ELITE',
        },
        {
          index: 3,
          title: 'TITLE_PRICE_PER',
          value: 'VALUE_PRICE_PER_ELITE',
        },
        {
          index: 4,
          title: 'TITLE_RETURN_PERIOD',
          value: 'VALUE_RETURN_PERIOD_ELITE',
        },
        {
          index: 8,
          title: 'TITLE_RETURN_RATE',
          value: 'VALUE_RETURN_RATE_ELITE',
        },
      ],
    },
  ];

  return { imgs: imgs, nfts: data };
};

export const get2ndSaleNftInfos = () => {
  const list = getNftInfos();
  const data = list.nfts.filter((e) => e.title !== 'GRADE_N');
  return { imgs: list.imgs, nfts: data };
};
